import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import brand from './modules/brand'
import category from './modules/category'
import language from './modules/language'
import game from './modules/game'
import territory from './modules/territory'
import gameOrder from './modules/game-order'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    namespaced: true,
    category,
    auth,
    brand,
    language,
    game,
    territory,
    gameOrder
  },
  namespaced: true
})

export default store
